import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';

export default withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.white.main,
    boxShadow: theme.customShadows[1],
  },
}))(AppBar);
